


















import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import useDelivery from '@/useDelivery';

const CommonTimeline = defineComponent({
  props: {
    log: {},
    index: {},
    length: {},
  },
  setup() {
    const { translate } = useDelivery();
    function dateFormat(date: string) {
      return useFormat.date(date).displayShortThaiDateTime();
    }
    function dateFormatWithoutTime(date: string) {
      return useFormat.date(date).displayShortThaiDate();
    }
    return {
      dateFormat,
      dateFormatWithoutTime,
      translate,
    };
  },
});

export default CommonTimeline;
